// extracted by mini-css-extract-plugin
export default {"TextField":"TextFieldV3_TextField__p9Uqb","normal":"TextFieldV3_normal__VrLVv","huge":"TextFieldV3_huge__+ye1E","label":"TextFieldV3_label__mDNsd"};